/* ===========================================================================
   KC cart drawer: device upsell, memory-card upsell, shipping protection,
   discount code, savings summary.

   WHY IT IS INJECTED RATHER THAN BUILT INTO THE SECTION
   sections/cart-drawer.liquid is re-rendered by the theme on every cart
   change, so anything written into it is thrown away and rebuilt. This module
   watches for that and re-injects, which also means the section file is left
   untouched and the whole feature can be removed by deleting two assets.

   THE LADDER IS THE CART'S, NOT A SEPARATE OFFER
   Kaching discounts on total DEVICE count across different products, verified
   against the live cart on 2026-09-22: 2 devices 8%, 3 devices 10%, and a
   camera plus a doorbell plus an indoor cam all counted together. Memory cards
   are correctly NOT devices -- a camera plus a card stays at 0%. So the upsell
   here is "one more device moves the whole cart up a rung", and the figures it
   quotes are the ones Kaching will actually apply.

   Keep LADDER in step with Kaching by hand. Nothing here charges anything;
   Kaching does, at the cart.
   =========================================================================== */
(function () {
  'use strict';

  /* Devices that count toward the ladder. */
  var DEVICES = [
    { id: 51761813946642, name: 'Solar Cam Pro 3.0',  price: 329, img: 'https://cdn.shopify.com/s/files/1/0534/5761/7046/files/Untitleddesign_97_160x.png?v=1765187764' },
    { id: 50981518377234, name: 'Solar Cam 2.0 4G (SIM required)', price: 329, img: 'https://cdn.shopify.com/s/files/1/0534/5761/7046/files/Untitled_design_55_160x.png' },
    { id: 52371307102482, name: 'Lumis Pro',          price: 397, img: 'https://cdn.shopify.com/s/files/1/0534/5761/7046/files/Untitleddesign_1_160x.png?v=1781566478' },
    { id: 51980763463954, name: 'Home Guardian',      price: 119, img: 'https://cdn.shopify.com/s/files/1/0534/5761/7046/files/Untitled_design_-_2026-02-02T082715.407_160x.png?v=1769985313' },
    { id: 51416958566674, name: 'DoorMate Doorbell',  price: 299, img: 'https://cdn.shopify.com/s/files/1/0534/5761/7046/files/main_picture_2_160x.png?v=1753134381' }
  ];

  /* Memory cards. The two big ones only fit the Solar Cam Pro 3.0, so they are
     hidden unless one is in the cart -- offering a card the customer's camera
     cannot read is a refund, not an upsell. */
  /* Card compatibility is per camera, not a single "big cards" flag:
     64GB and 128GB fit everything, 256GB fits the Solar Cam Pro 3.0, the Lumis
     Pro and the DoorMate, 512GB is Solar Cam Pro 3.0 only. `fits: null` means
     any camera.
     Selling a card a customer's camera cannot read is a refund, so a card is
     offered only when a camera that takes it is already in the cart. */
  var SC3_ID   = 51761813946642;
  var LUMIS_ID = 52371307102482;
  var DOOR_ID  = 51416958566674;
  var CARDS = [
    { id: 47470136099090, size: '64GB',  price: 39,  fits: null },
    { id: 47470136131858, size: '128GB', price: 73,  fits: null },
    { id: 51776734757138, size: '256GB', price: 153, fits: [SC3_ID, LUMIS_ID, DOOR_ID] },
    { id: 51776736166162, size: '512GB', price: 299, fits: [SC3_ID] }
  ];
  var CARD_IMG = 'https://cdn.shopify.com/s/files/1/0534/5761/7046/files/64gb-tf-micro-card-481118_61d8b380-b7fe-40e5-a3e8-a091744cf7d0_160x.jpg?v=1699890606';

  var SHIP_ID = 52729829982482;
  var SHIP_PRICE = 4.99;

  /* devices -> percent off. Mirrors the Kaching device ladder. */
  function pctFor(n) {
    if (n >= 5) return 15;
    if (n === 4) return 12;
    if (n === 3) return 10;
    if (n === 2) return 8;
    return 0;
  }

  /* Remembers an explicit "no". Protection is OPT-IN (2026-10-01): see
     maybeAddProtection, which no longer adds anything. */
  var OPT_OUT = 'kcShipProtOff';
  var DEV_ADDED  = 'kcDeviceAdded';    /* the device offer is a one-shot, not a nag */
  var busy = false;

  /* Records the shopper's "no" for later. Nothing reads it while protection is
     opt-in -- nothing adds protection at all -- but the toggle keeps writing it
     so that if a default is ever switched back on it cannot immediately re-add
     what someone has just taken off. Written to BOTH stores: sessionStorage is
     per-tab, so an in-app browser (which starts a fresh session every time)
     would forget the choice; localStorage makes it stick to the device. Any
     future default must read both. */
  function setOptedOut() {
    try { sessionStorage.setItem(OPT_OUT, '1'); } catch (e) {}
    try { localStorage.setItem(OPT_OUT, '1'); } catch (e) {}
  }
  function clearOptedOut() {
    try { sessionStorage.removeItem(OPT_OUT); } catch (e) {}
    try { localStorage.removeItem(OPT_OUT); } catch (e) {}
  }

  function money(n) {
    return '$' + Number(n).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function money0(n) {
    return '$' + Math.round(Number(n)).toLocaleString('en-AU');
  }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  /* PostHog, added 2026-10-01 (brief item 8). Additive and never load-bearing:
     a blocked, absent or throwing posthog must not be able to affect the cart,
     so every call goes through here inside a try/catch. */
  function kcTrack(name, props) {
    try { if (window.posthog && window.posthog.capture) window.posthog.capture(name, props); } catch (e) {}
  }
  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        /* Shopify answers a refused add with JSON AND a 4xx. Resolving on that
           made every failure look like a success: the line was never added, yet
           the caller repainted as though it had been. */
        if (!r.ok) {
          var e = new Error(j.description || j.message || ('Cart request failed (' + r.status + ')'));
          e.status = r.status;
          throw e;
        }
        return j;
      });
    });
  }
  /* Tell the theme to re-render from the server.

     ONLY 'cart:refresh'. The theme's own 'cart:change' carries a payload --
     it dispatches { detail: { baseEvent, cart } } where cart also holds the
     rendered `sections` -- and every listener reads it without guarding:
       document.addEventListener('cart:change', e => fetchCart = e.detail.cart)
       CartCount:      e.detail.cart.item_count
       cart-drawer:    e.detail.cart.sections[sectionId]
       free-ship bar:  e.detail.cart.items.filter(...)
     Firing it bare threw in all of them, so the header count, the shipping
     progress bar and the drawer's own re-render silently stopped updating and
     PostHog logged ~800 exceptions a day from the day this shipped.
     'cart:refresh' takes no detail by design: the drawer refetches its section
     and CartCount re-reads the cart, which is exactly what is wanted here. */
  var refreshQueued = false;
  function refresh() {
    /* Never ask the theme to redraw under a finger -- see handsOff. But a
       blocked redraw must not be dropped: the shopper who just flipped the
       protection toggle is standing in the footer, so their own change would
       be the one that never lands. Hold it and retry until the hand lifts. */
    if (handsOff()) {
      if (refreshQueued) return;
      refreshQueued = true;
      window.setTimeout(function () { refreshQueued = false; refresh(); }, 300);
      return;
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  /* --------------------------------------------------------- checkout guard

     The theme answers 'cart:refresh' by REPLACING every child of #cart-drawer,
     footer and buy-buttons form included. Two ways that loses a sale:

       1. It lands between the shopper's finger going down and the click
          resolving. The button they aimed at no longer exists, so the tap hits
          nothing and nothing happens -- the reported "I click checkout and it
          doesn't load".
       2. It lands after submit. A form has to be connected to a document to
          submit, so replacing it cancels the navigation outright, and
          CustomButton has already swapped the label for its three dots.

     The window is not theoretical: the shipping-protection auto-add fires a
     write the instant the drawer opens, which is exactly when a quick shopper
     is reaching for Checkout.

     So once a finger is on the footer, or a checkout submit is in flight, we
     hold off the two things that can destroy that form: refresh(), which asks
     the theme to replace the drawer, and maybeAddProtection(), which starts a
     write that ends in a refresh().

     inject() and render() are deliberately NOT held off. clearOurs() only ever
     removes our own nodes -- .kc-cart-built, .kc-sp, .kc-sv, .kc-dc, .kc-was --
     and never form.buy-buttons, so our own paint cannot take the button away.
     Holding them off would be actively wrong: the protection toggle lives in
     the footer, so flipping it puts a finger there, and gating the paint on
     that would leave the shopper's own change unpainted. */
  var checkingOut = false;      /* submit fired; hands off until we navigate */
  var handsOffUntil = 0;        /* ms timestamp; a pointer is on the footer */
  /* 2026-10-01 (discount fix): a focused discount field counts as hands-on.
     Without this, a redraw -- the protection default's commit, or the theme
     redraw the replace guard re-asks for the moment the finger lifts --
     rebuilds the drawer while the shopper is typing a code. The field empties
     and the keyboard closes, which is what was reported on the preview.

     Scoped to .kc-dc, deliberately NOT to every input in the drawer. The
     theme's own .quantity-input (type=number) sits inside #cart-drawer and is
     focused whenever someone types a quantity, so a drawer-wide test would make
     handsOff() true for as long as that field held focus: the quantity change's
     own redraw would never land, the total would sit stale behind it, and both
     refresh() and the guard re-ask would poll in the background the whole
     time. */
  function typingInDrawer() {
    var a = document.activeElement;
    return !!(a && (a.tagName === 'INPUT' || a.tagName === 'TEXTAREA') &&
              a.type !== 'checkbox' && a.closest &&
              a.closest('#cart-drawer') && a.closest('.kc-dc'));
  }
  function handsOff() { return checkingOut || Date.now() < handsOffUntil || typingInDrawer(); }

  /* After any write, re-read the cart and repaint from THAT, not from whatever
     was cached before the write. Calling refresh() alone let a fetch already in
     flight -- issued before the write landed -- win the race and repaint stale
     state, which is what flipped the protection toggle straight back off. */
  function commit() {
    return getCart().then(function (cc) {
      lastCart = cc;
      builtFor = null;                 /* force a repaint even if the DOM looks built */
      quietly(function () { inject(cc); });
      refresh();                       /* let the theme redraw its own totals */
      return cc;
    });
  }

  function deviceInfo(cart) {
    var count = 0, subtotal = 0, cards = 0, hasSC3 = false, hasCard = false, hasShip = false;
    var ids = {};
    (cart.items || []).forEach(function (it) {
      var d = DEVICES.filter(function (x) { return x.id === it.id; })[0];
      if (d) { count += it.quantity; subtotal += (it.original_line_price / 100); ids[it.id] = true; }
      if (it.id === SC3_ID) hasSC3 = true;
      if (CARDS.some(function (c) { return c.id === it.id; })) { hasCard = true; cards += it.quantity; }
      if (it.id === SHIP_ID) hasShip = true;
    });
    return { count: count, subtotal: subtotal, cards: cards, ids: ids,
             hasSC3: hasSC3, hasCard: hasCard, hasShip: hasShip };
  }

  /* ---------------------------------------------------------------- blocks */

  function buildDeviceUpsell(cart, info) {
    var next = pctFor(info.count + 1), cur = pctFor(info.count);
    if (info.count < 1 || next <= cur) return null;          /* nothing to unlock */

    /* Offer it once. Once the shopper has taken it, the drawer falls back to
       the small add-ons rather than asking for another camera. */
    try { if (sessionStorage.getItem(DEV_ADDED) === '1') return null; } catch (e) {}

    var box = el('div', 'kc-cu kc-cu--device');
    var head = el('div', 'kc-cu__head');
    head.appendChild(el('b', null, 'Add 1 more device'));
    head.appendChild(el('span', 'kc-cu__pill', 'SAVE ' + next + '%'));
    box.appendChild(head);

    var row = el('div', 'kc-cu__row');
    var thumb = el('img', 'kc-cu__img'); thumb.loading = 'lazy'; thumb.alt = '';
    row.appendChild(thumb);

    var sel = el('select', 'kc-cu__select');
    sel.setAttribute('aria-label', 'Choose a device to add');
    DEVICES.forEach(function (d) {
      var o = el('option', null, d.name + ' — ' + money0(d.price));
      o.value = String(d.id);
      sel.appendChild(o);
    });
    var mid = el('div', 'kc-cu__mid');
    mid.appendChild(sel);
    var prices = el('div', 'kc-cu__prices');
    var was = el('s', 'kc-cu__was');
    var now = el('b', 'kc-cu__now');
    prices.appendChild(was); prices.appendChild(now);
    mid.appendChild(prices);
    var saveTag = el('span', 'kc-cu__save');
    mid.appendChild(saveTag);
    var scope = el('span', 'kc-cu__scope', next + '% comes off this device and the ones already in your cart');
    mid.appendChild(scope);
    row.appendChild(mid);

    var btn = el('button', 'kc-cu__btn', 'ADD TO CART');
    btn.type = 'button';
    row.appendChild(btn);
    box.appendChild(row);

    function paint() {
      var d = DEVICES.filter(function (x) { return String(x.id) === sel.value; })[0];
      if (!d) return;
      thumb.src = d.img;
      /* Price the device being added, on its own. The ladder also discounts
         what is already in the cart, but quoting the whole basket here reads
         like the price of this one item and confuses people. */
      var gross = d.price;
      var net = gross * (1 - next / 100);
      was.textContent = money(gross);
      now.textContent = money(net);
      saveTag.textContent = 'SAVE ' + money(gross - net);
    }
    sel.addEventListener('change', paint);
    paint();

    btn.addEventListener('click', function () {
      if (busy) return;
      busy = true;
      btn.disabled = true;
      btn.textContent = 'ADDING…';
      post('/cart/add.js', { items: [{ id: Number(sel.value), quantity: 1 }] })
        .then(function () {
          try { sessionStorage.setItem(DEV_ADDED, '1'); } catch (e) {}
          return commit();
        })
        .catch(function () { btn.textContent = 'ADD TO CART'; btn.disabled = false; })
        .finally(function () { busy = false; });
    });
    return box;
  }

  function cardFits(card, info) {
    if (!card.fits) return true;                 /* fits every camera */
    for (var i = 0; i < card.fits.length; i++) {
      if (info.ids[card.fits[i]]) return true;   /* a camera that takes it is in the cart */
    }
    return false;
  }

  function buildCardUpsell(cart, info) {
    /* One card per camera, same rule as the buy box. Once they hold as many
       cards as cameras there is nothing left to sell them here. */
    var room = info.count - info.cards;
    if (info.count < 1 || room < 1) return null;

    var box = el('div', 'kc-cu kc-cu--card');
    var head = el('div', 'kc-cu__head');
    head.appendChild(el('b', null, 'Add Micro TF Cards'));
    head.appendChild(el('span', 'kc-cu__pill kc-cu__pill--ink', '$0/MONTH'));
    box.appendChild(head);

    var row = el('div', 'kc-cu__row');
    var thumb = el('img', 'kc-cu__img'); thumb.src = CARD_IMG; thumb.loading = 'lazy'; thumb.alt = '';
    row.appendChild(thumb);

    var mid = el('div', 'kc-cu__mid');
    var sel = el('select', 'kc-cu__select');
    sel.setAttribute('aria-label', 'Choose a memory card size');
    CARDS.filter(function (c) { return cardFits(c, info); }).forEach(function (c) {
      var o = el('option', null, c.size + ' — ' + money0(c.price));
      o.value = String(c.id);
      sel.appendChild(o);
    });
    mid.appendChild(sel);

    /* Quantity, capped at one per camera. With a single camera there is only
       ever one choice, so the control would be furniture. */
    var qty = null;
    if (room > 1) {
      qty = el('select', 'kc-cu__select kc-cu__qty');
      qty.setAttribute('aria-label', 'How many cards');
      for (var i = 1; i <= room; i++) {
        var o = el('option', null, i + (i === 1 ? ' card' : ' cards'));
        o.value = String(i);
        qty.appendChild(o);
      }
      mid.appendChild(qty);
    }

    var scope = el('span', 'kc-cu__scope');
    mid.appendChild(scope);
    row.appendChild(mid);

    var btn = el('button', 'kc-cu__btn', 'ADD');
    btn.type = 'button';
    row.appendChild(btn);
    box.appendChild(row);

    function paint() {
      var c = CARDS.filter(function (x) { return String(x.id) === sel.value; })[0];
      var q = qty ? Number(qty.value) : 1;
      var note = '';
      if (c && c.fits) {
        var names = c.fits.map(function (id) {
          var d = DEVICES.filter(function (x) { return x.id === id; })[0];
          return d ? d.name : '';
        }).filter(Boolean);
        if (names.length) note = ' Fits ' + names.join(' and ') + '.';
      }
      scope.textContent = (room > 1 ? 'One per camera — up to ' + room + '. ' : '') +
        'Keep and replay your footage without a subscription.' + note +
        (c ? '  ' + money0(c.price * q) : '');
    }
    sel.addEventListener('change', paint);
    if (qty) qty.addEventListener('change', paint);
    paint();

    btn.addEventListener('click', function () {
      if (busy) return;
      busy = true;
      btn.disabled = true;
      btn.textContent = 'ADDING…';
      post('/cart/add.js', { items: [{ id: Number(sel.value), quantity: qty ? Number(qty.value) : 1 }] })
        .then(commit)
        .catch(function () { btn.textContent = 'ADD'; btn.disabled = false; })
        .finally(function () { busy = false; });
    });
    return box;
  }

  function buildShipProtection(cart, info) {
    if (!(cart.items || []).length) return null;

    var box = el('label', 'kc-sp');
    var cb = el('input');
    cb.type = 'checkbox';
    cb.className = 'kc-sp__cb';
    cb.checked = info.hasShip;
    box.appendChild(cb);
    box.appendChild(el('span', 'kc-sp__track'));

    var txt = el('span', 'kc-sp__txt');
    txt.appendChild(el('b', null, 'Shipping Protection'));
    txt.appendChild(el('span', null, 'In case of loss or damage in transit'));
    box.appendChild(txt);

    var right = el('span', 'kc-sp__right');
    right.appendChild(el('b', null, money(SHIP_PRICE)));
    right.appendChild(el('span', 'kc-sp__badge', 'Guaranteed delivery'));
    box.appendChild(right);

    var warn = el('span', 'kc-sp__warn');
    warn.hidden = true;
    box.appendChild(warn);

    cb.addEventListener('change', function () {
      if (busy) { cb.checked = !cb.checked; return; }
      busy = true;
      warn.hidden = true;
      if (cb.checked) {
        clearOptedOut();
        post('/cart/add.js', { items: [{ id: SHIP_ID, quantity: 1 }] })
          .then(commit)
          .catch(function (err) {
            cb.checked = false;
            warn.textContent = err.message || 'Could not add protection.';
            warn.hidden = false;
          })
          .finally(function () { busy = false; });
      } else {
        /* Remember the choice, or the auto-add below would put it straight back. */
        setOptedOut();
        var line = (cart.items || []).filter(function (i) { return i.id === SHIP_ID; })[0];
        if (!line) { busy = false; return; }
        post('/cart/change.js', { id: line.key, quantity: 0 })
          .then(commit).finally(function () { busy = false; });
      }
    });
    return box;
  }

  function decorateTotal(footer, cart) {
    var orig = cart.original_total_price, now = cart.total_price;
    if (!(orig > now)) return;
    var first = footer.querySelector('.h5');
    var row = first ? first.closest('.h-stack') : null;
    if (!row) return;
    var cells = row.querySelectorAll('.h5');
    var value = cells[cells.length - 1];
    if (!value || value === first || value.querySelector('.kc-was')) return;
    value.insertBefore(el('s', 'kc-was', money(orig / 100)), value.firstChild);
  }

  function buildSavings(cart) {
    var saved = (cart.original_total_price - cart.total_price) / 100;
    if (saved <= 0) return null;
    var box = el('div', 'kc-sv');
    box.appendChild(el('span', 'kc-sv__label', 'Total Savings:'));
    box.appendChild(el('b', 'kc-sv__amt', money(saved)));
    return box;
  }

  /* Discount code, applied IN PLACE (2026-10-01).

     It used to be window.location.href = '/discount/CODE?redirect=/' -- a full
     page load that dumped the shopper on the HOME page, and that said nothing
     at all when the code did not apply. Shopify stores a code it cannot use
     with applicable:false and reports no error, so "the whole screen refreshed
     and nothing applied" was the designed behaviour, not a preview fault. It
     happens on a code that does not exist, a code under its minimum spend, and
     a once-per-customer code the shopper has already used.

     POST /cart/update.js with `discount` applies the code to the cart and
     answers with discount_codes[].applicable, so the shopper gets a clear
     yes/no without leaving the page.

     THE REPLACE TRAP (fixed 2026-10-01, round 3). `discount` REPLACES whatever
     codes the cart carries; MAIN's old /discount/CODE route ADDED to them. So
     the first version of this silently threw away a working code the moment a
     second one was typed: with WELCOME5GBNVG applied on 2 Pros ($575.10),
     typing WELCOME5 (which does not exist) showed "can't be applied", dropped
     WELCOME5GBNVG without a word, and put the total back to $605.36 -- worse
     than the full page load it replaced, because the shopper was told the new
     code failed and not that their old one had gone.

     So we send the codes the cart already has AND the new one, as the comma
     list `discount` accepts, de-duplicated case-insensitively. Shopify then
     keeps what still applies and marks the rest inapplicable: sending
     "WELCOME5GBNVG,WELCOME5" holds $575.10. The verdict shown is for the NEW
     code only -- the others are not what the shopper just asked about.

     Shopify's own combination rules still decide the outcome, so a
     non-combinable new code can legitimately push an old one out. That is the
     same as the /discount/ route did and is not ours to override.

     dcDraft/dcMsg live outside the node because clearOurs() destroys and
     rebuilds .kc-dc on every repaint, so anything held on the element is lost.

     Three changes from the drafted version:
      - a failed request only falls back to /discount/CODE when there was NO
        HTTP response. An HTTP error used to navigate as well, which brought
        back the exact full-page-reload-with-no-feedback this fix exists to
        remove, in the most likely failure case.
      - dcMsg is cleared the moment the shopper types again. Left as drafted it
        is never cleared, so "applied" or an error would be re-rendered on every
        later repaint for the rest of the page's life.
      - the message carries an ok/bad class so it can be coloured, and the
        fallback returns to THIS page, query string included, rather than the
        home page -- otherwise it drops preview_theme_id and lands on live. */
  var dcDraft = '', dcMsg = '', dcOk = false, dcCode = '';

  /* Existing applicable codes plus the new one, de-duplicated case-insensitively
     and with the new code last. Read from lastCart, which commit() refreshes
     after every write, so it is the cart the drawer is currently showing. */
  function codesToSend(newCode) {
    var cart = lastCart || {};
    var out = [], seen = {};
    (cart.discount_codes || []).filter(function (d) { return d && d.applicable; })
      .map(function (d) { return String(d.code); })
      .concat([newCode])
      .forEach(function (c) {
        if (!c) return;
        var k = String(c).toUpperCase();
        if (seen[k]) return;
        seen[k] = 1;
        out.push(c);
      });
    return out.join(',');
  }

  /* An "applied" verdict goes stale when the cart changes under it -- removing
     items can take a code back below its minimum. Re-check it against the cart
     on every repaint and drop it once the code is no longer applicable. A
     "can't be applied" message is left alone: that one is about the code the
     shopper typed, not about the cart, and typing clears it. */
  function verdictStale(cart) {
    if (!dcMsg || !dcOk || !dcCode) return false;
    return !((cart || {}).discount_codes || []).some(function (d) {
      return d && d.applicable && String(d.code).toUpperCase() === dcCode;
    });
  }

  function buildDiscount(cart) {
    if (verdictStale(cart || lastCart)) { dcMsg = ''; dcOk = false; dcCode = ''; }
    var box = el('form', 'kc-dc');
    var input = el('input', 'kc-dc__input');
    input.type = 'text';
    input.placeholder = 'Discount code';
    input.setAttribute('aria-label', 'Discount code');
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('autocapitalize', 'characters');
    input.setAttribute('spellcheck', 'false');
    input.value = dcDraft;
    var btn = el('button', 'kc-dc__btn', 'Apply');
    btn.type = 'submit';
    var msg = el('span', 'kc-dc__msg', dcMsg || null);
    if (dcMsg) msg.className = 'kc-dc__msg ' + (dcOk ? 'kc-dc__msg--ok' : 'kc-dc__msg--bad');
    msg.setAttribute('role', 'status');
    msg.hidden = !dcMsg;
    input.addEventListener('input', function () {
      dcDraft = input.value;
      if (dcMsg) {                      /* a new code: the old verdict is stale */
        dcMsg = ''; dcOk = false;
        msg.textContent = ''; msg.className = 'kc-dc__msg'; msg.hidden = true;
      }
    });
    box.appendChild(btn); box.appendChild(input); box.appendChild(msg);   /* Apply on the left, clear of the chat bubble */

    function say(text, ok, forCode) {
      dcMsg = text; dcOk = !!ok; dcCode = ok ? String(forCode || '').toUpperCase() : '';
      msg.textContent = text;
      msg.className = 'kc-dc__msg ' + (ok ? 'kc-dc__msg--ok' : 'kc-dc__msg--bad');
      msg.hidden = false;
    }

    /* Node only, deliberately not remembered in dcMsg: this is a transient
       "hold on", not a verdict about a code, so a repaint should lose it. */
    function flash(text) {
      msg.textContent = text;
      msg.className = 'kc-dc__msg';
      msg.hidden = false;
    }

    box.addEventListener('submit', function (e) {
      e.preventDefault();
      var code = (input.value || '').trim();
      if (!code) return;
      /* Another cart write is in flight -- an upsell add, the protection
         toggle. Say so instead of swallowing the tap, which looked like a dead
         button. */
      if (busy) { flash('Just a moment — the cart is still updating.'); return; }
      busy = true;
      btn.disabled = true;
      btn.textContent = '…';
      input.blur();                     /* release the typing hold so the repaint can land */
      post('/cart/update.js', { discount: codesToSend(code) })
        .then(function (c) {
          var hit = (c.discount_codes || []).filter(function (d) {
            return String(d.code).toUpperCase() === code.toUpperCase();
          })[0];
          if (hit && hit.applicable) { say(code.toUpperCase() + ' applied', true, code); dcDraft = ''; }
          else say('“' + code + '” can’t be applied to this cart', false);
          /* item 8. Deliberately AFTER the two branches rather than inside them:
             the brief requires an added-lines-only diff on this file, and
             wrapping those single-statement branches in blocks would have
             rewritten them. */
          if (hit && hit.applicable) {
            kcTrack('discount_applied', {
              code: code.toUpperCase(),
              cart_total: (c.total_price || 0) / 100,
              item_count: c.item_count
            });
          } else {
            kcTrack('discount_rejected', { code: code.toUpperCase(), reason: 'not_applicable' });
          }
          return commit();
        })
        .catch(function (err) {
          /* An HTTP status means Shopify answered, so say so here rather than
             throwing the shopper at a page load. Only a request that never got
             a response falls back to the old route. */
          /* item 8, before the early return on the next line. */
          if (err && err.status) kcTrack('discount_rejected', { code: code.toUpperCase(), reason: 'http_error' });
          if (err && err.status) { say('Could not apply that code just now.', false); return; }
          try { sessionStorage.setItem('kcOpenDrawer', '1'); } catch (e2) {}
          window.location.href = '/discount/' + encodeURIComponent(code) +
            '?redirect=' + encodeURIComponent(window.location.pathname + window.location.search);
        })
        .finally(function () { busy = false; btn.disabled = false; btn.textContent = 'Apply'; });
    });
    return box;
  }

  /* ---------------------------------------------------------------- inject */

  /* The theme rebuilds the drawer's innards from the server on every cart
     change, which wipes our markup. Re-fetching the cart before repainting
     leaves a visible hole for the length of a round trip -- that is the flash.
     So we keep the last cart, repaint from it synchronously the moment our
     markup disappears, and only swap in fresh numbers once they arrive. */
  var lastCart = null;
  var builtFor = null;      /* fingerprint of the cart the current DOM shows */
  var mo = null;

  function drawerEl() { return document.querySelector('#cart-drawer'); }

  function fingerprint(cart) {
    return (cart.items || []).map(function (i) { return i.id + 'x' + i.quantity; }).join(',') +
           '|' + cart.total_price + '|' + cart.original_total_price;
  }

  /* Our own writes must not feed the observer, or injecting re-triggers a
     render which injects again. */
  function quietly(fn) {
    var d = drawerEl();
    if (mo) mo.disconnect();
    try { fn(); } finally { if (mo && d) mo.observe(d, { childList: true, subtree: true }); }
  }

  function clearOurs(drawer) {
    ['.kc-cart-built', '.kc-sp', '.kc-sv', '.kc-dc', '.kc-was'].forEach(function (s) {
      var n = drawer.querySelectorAll(s);
      for (var i = 0; i < n.length; i++) n[i].remove();
    });
  }

  /* Protection is controlled by the toggle in the footer, so the line for it in
     the item list is a second, contradictory control -- with its own quantity
     box and Remove link. Hide the line and take it out of the drawer's count so
     the badge matches the rows on screen. Keyed off the variant id in
     data-line-key, not the product title, so a rename cannot break it. */
  function hideProtectionLine(drawer, cart) {
    var items = drawer.querySelector('.cart-drawer__line-items');
    if (items) {
      var lines = items.querySelectorAll('line-item, .line-item');
      for (var i = 0; i < lines.length; i++) {
        var k = lines[i].querySelector('[data-line-key]');
        var key = k ? (k.getAttribute('data-line-key') || '') : '';
        var a = lines[i].querySelector('a[href*="/products/"]');
        var href = a ? (a.getAttribute('href') || '') : '';
        if (key.indexOf(SHIP_ID + ':') === 0 || href.indexOf('/products/shipping-protection') > -1) {
          lines[i].classList.add('kc-line-hidden');
        }
      }
    }
    var ship = 0;
    (cart.items || []).forEach(function (it) { if (it.id === SHIP_ID) ship += it.quantity; });
    if (!ship) return;
    var shown = Math.max(0, (cart.item_count || 0) - ship);
    var bubbles = drawer.querySelectorAll('cart-count');
    /* Only write when it actually differs. The theme's CartCount animates on
       every change, so a redundant write is a visible twitch. */
    for (var j = 0; j < bubbles.length; j++) {
      if (bubbles[j].textContent !== String(shown)) bubbles[j].textContent = String(shown);
    }
  }

  function inject(cart) {
    var drawer = drawerEl();
    if (!drawer) return;

    var items = drawer.querySelector('.cart-drawer__line-items');
    var footer = drawer.querySelector('[slot="footer"]');
    if (!items || !footer) return;

    var fp = fingerprint(cart);
    if (drawer.querySelector('.kc-cart-built') && builtFor === fp) return;   /* already correct */

    clearOurs(drawer);

    var info = deviceInfo(cart);

    var wrap = el('div', 'kc-cart-built');
    [buildDeviceUpsell(cart, info), buildCardUpsell(cart, info)].forEach(function (b) {
      if (b) wrap.appendChild(b);
    });
    items.insertAdjacentElement('afterend', wrap);

    var sp = buildShipProtection(cart, info);
    if (sp) footer.insertAdjacentElement('afterbegin', sp);

    var form = footer.querySelector('form.buy-buttons');
    if (form) form.insertAdjacentElement('beforebegin', buildDiscount(cart));

    decorateTotal(footer, cart);

    var sv = buildSavings(cart);
    if (sv) {
      var total = footer.querySelector('.h5');
      var host = total ? total.closest('.h-stack') : null;
      if (host) host.insertAdjacentElement('afterend', sv);
      else footer.insertAdjacentElement('afterbegin', sv);
    }

    hideProtectionLine(drawer, cart);

    builtFor = fp;

    maybeAddProtection(cart, info);
  }

  /* Protection is OPT-IN (2026-10-01, owner's call, reverting the default that
     was briefly built here). NOTHING in this file adds it. The shopper ticks the
     toggle, which is the only path that ever posts the protection variant, and
     an untick removes it.

     The default is gone rather than disabled, deliberately. While it existed it
     cost three separate defects: it fired a cart write the instant the drawer
     opened, which rebuilt the discount box under whoever was typing in it; it
     was re-added behind the shopper's own Remove link on /cart; and it put a
     $4.99 charge in front of someone mid-decision with no line item against it.

     What remains are corrections only, and they are corrections whatever the
     default is:
       - a protection-only cart is cleaned up, so removing the last product does
         not leave a $4.99 cart with a hidden line and a badge reading 0
       - a cart carrying two protection lines is repaired back to one
     Kept under the same name so the asset monitor's token check still holds. */
  var sawShip = false;        /* did the cart we last looked at carry protection? */

  function maybeAddProtection(cart, info) {
    var items = cart.items || [];
    var line = items.filter(function (i) { return i.id === SHIP_ID; })[0];
    var hasProducts = items.some(function (i) { return i.id !== SHIP_ID; });

    /* B1 (2026-10-01): protection can be taken off somewhere kc-cart does not
       own -- the /cart page lists it as an ordinary line with its own Remove
       link, and checkout's "Return to cart" lands there. The toggle writes
       OPT_OUT; that Remove link cannot. So record protection vanishing from a
       cart that still holds products as the shopper saying no, wherever they
       did it. Guarded on hasProducts, because emptying the cart is not an
       opt-out and neither is the clean-up below.
       Nothing re-adds it in any case -- that is what actually makes a removal
       on /cart stick -- but the record has to be right if a default ever
       returns. */
    if (sawShip && !line && hasProducts) setOptedOut();
    sawShip = !!line;

    if (busy || handsOff()) return;

    /* Do not leave a protection-only cart behind. If the last product has gone,
       take protection off too: otherwise the cart still charges $4.99 with its
       line hidden in the drawer, the drawer badge reads 0 and the header badge
       reads 1. */
    if (line && !hasProducts) {
      busy = true;
      post('/cart/change.js', { id: line.key, quantity: 0 })
        .then(commit).finally(function () { busy = false; });
      return;
    }

    /* Repair: earlier builds could re-add on every redraw, so some carts carry
       more than one line. Nobody needs two. */
    if (line && line.quantity > 1) {
      busy = true;
      post('/cart/change.js', { id: line.key, quantity: 1 })
        .then(commit).finally(function () { busy = false; });
      return;
    }
  }

  /* Repaint from cache first (instant), then reconcile with the server. */
  var pending = false, dirty = false;
  function render() {
    if (!drawerEl()) return;
    installReplaceGuards();            /* cheap; no-ops once both nodes are wrapped */
    if (lastCart) quietly(function () { inject(lastCart); });
    if (pending) { dirty = true; return; }   /* re-run after, never just drop it */
    pending = true;
    getCart().then(function (c) {
      lastCart = c;
      quietly(function () { inject(c); });
    }).catch(function () {}).finally(function () {
      pending = false;
      if (dirty) { dirty = false; render(); }
    });
  }

  /* Gorgias floats its launcher bottom-right, on top of the drawer footer.
     Flag the open state on <html> so the stylesheet can take it out of the
     way while the drawer is up. */
  function trackOpen() {
    var drawer = drawerEl();
    if (!drawer) return;
    var sync = function () {
      var open = drawer.hasAttribute('open');
      if (!open) {
        var r = drawer.getBoundingClientRect();
        open = r.width > 0 && r.height > 0 && r.right > 0 && r.left < window.innerWidth &&
               getComputedStyle(drawer).visibility !== 'hidden';
      }
      document.documentElement.classList.toggle('kc-drawer-open', !!open);
    };
    new MutationObserver(sync).observe(drawer, {
      attributes: true, attributeFilter: ['open', 'class', 'style', 'aria-hidden']
    });
    drawer.addEventListener('transitionend', sync);
    document.addEventListener('click', function () { setTimeout(sync, 60); }, true);
    document.addEventListener('keyup', function (e) { if (e.key === 'Escape') setTimeout(sync, 60); });
    sync();
  }

  function watch() {
    var drawer = drawerEl();
    if (!drawer) return;
    mo = new MutationObserver(function () {
      installReplaceGuards();          /* a new footer node needs wrapping too */
      if (!drawer.querySelector('.kc-cart-built')) render();
    });
    mo.observe(drawer, { childList: true, subtree: true });
  }

  /* ----------------------------------------------- drawer replace guard
     TEMPORARY -- added 2026-10-01. To be removed once kc-cart's own writes ask
     for `sections: 'cart-drawer'` on /cart/add.js and /cart/change.js and patch
     the drawer straight from that response instead of dispatching
     'cart:refresh'. That removes the second section fetch and the full-drawer
     replacement, so this race stops existing structurally and this
     monkey-patch can be deleted. Until then it stays, with this date on it.

     handsOff() can only stop a refresh that has not been dispatched yet. One
     already in flight lands wherever it lands, and the theme answers it by
     calling replaceChildren() on one of two nodes:
       - #cart-drawer         ('cart:refresh' -> whole drawer, buy-buttons
                               form included)
       - [slot="footer"]      (the theme's own quantity-change path: theme.js
                               POSTs /cart/change.js with `sections`, then
                               CartDrawer._onCartChanged replaces the footer
                               IMMEDIATELY and synchronously -- no grace period
                               at all, which makes it the wider of the two
                               windows. It also replaces .cart-drawer__inner
                               1250ms later.)
     Both are wrapped, which is what folds the quantity-change race into the
     same fix as the protection-toggle one.

     While a checkout is in flight a replacement is DROPPED: we are leaving the
     page, and the 10s fallback re-renders if we never do. While a finger is in
     the drawer it is also dropped, and a FRESH refresh() is asked for once the
     hand lifts -- replaying the held nodes would paint state up to 1.5s old,
     which is how a wrong total ends up on screen; re-fetching costs one section
     request and is always right.

     Re-installed after every replacement, because replacing the drawer's
     children creates a brand-new footer node that would otherwise be unguarded,
     and from boot()/render() in case #cart-drawer is not in the DOM yet. */
  var navigating = false;
  var guardedFlush = 0;

  function installReplaceGuards() {
    var d = drawerEl();
    if (!d) return;
    guardReplace(d);
    guardReplace(d.querySelector('[slot="footer"]'));
  }

  function guardReplace(node) {
    if (!node || node.__kcReplaceGuard || typeof node.replaceChildren !== 'function') return;
    node.__kcReplaceGuard = true;
    var native = node.replaceChildren;
    node.replaceChildren = function () {
      if (checkingOut || handsOff()) { askGuardedRefresh(); return; }
      var r = native.apply(node, arguments);
      installReplaceGuards();            /* the footer we knew may have just gone */
      return r;
    };
  }

  /* One pending re-ask, however many replacements were dropped. */
  function askGuardedRefresh() {
    if (guardedFlush) return;
    guardedFlush = window.setTimeout(function flush() {
      if (handsOff()) { guardedFlush = window.setTimeout(flush, 200); return; }
      guardedFlush = 0;
      installReplaceGuards();
      refresh();
    }, 200);
  }

  /* Arms the guards above, and puts a deadline on the button's busy state.
     CustomButton swaps the Checkout label for three animated dots on submit and
     only restores it on pageshow. If the navigation never happens -- blocked in
     the theme editor, cancelled by an app, a dropped connection -- the shopper
     is left staring at a dead button with no way to retry. */
  function guardCheckout() {
    /* 2026-10-01: the guard zone is the whole drawer, not just the footer. On
       30 Sep kc-cart-layout.js moved .kc-sp and the discount box out of
       [slot="footer"] into the scrolling items area, so a press on either
       stopped counting. Any finger inside #cart-drawer now holds off redraws,
       wherever a layout script has chosen to put the control. */
    function inGuard(e) {
      var t = e.target;
      return !!(t && t.closest && t.closest('#cart-drawer'));
    }

    /* Down: hold off. 1.5s is only a ceiling for a press that never resolves.
       touchstart as well as pointerdown, because some in-app webviews deliver
       touch events before -- or instead of -- pointer events. */
    function down(e) { if (inGuard(e)) handsOffUntil = Math.max(handsOffUntil, Date.now() + 1500); }
    document.addEventListener('pointerdown', down, true);
    document.addEventListener('touchstart', down, { capture: true, passive: true });

    /* Up: the press is over, so release almost immediately. This has to be on
       pointerup/touchend and not only on click. A scroll gesture inside the
       drawer fires a pointerdown and never a click, so releasing on click alone
       meant every flick held the full 1.5s ceiling -- and because the guard zone
       is now the whole drawer, a shopper scrolling a long cart could hold their
       own redraws off indefinitely. A checkout submit fires after this and sets
       checkingOut, which keeps the hold regardless. */
    function up(e) { if (inGuard(e)) handsOffUntil = Math.min(handsOffUntil, Date.now() + 150); }
    document.addEventListener('pointerup', up, true);
    document.addEventListener('touchend', up, { capture: true, passive: true });
    document.addEventListener('touchcancel', up, { capture: true, passive: true });
    document.addEventListener('click', up, true);

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.classList || !form.classList.contains('buy-buttons')) return;
      checkingOut = true;
      var btn = form.querySelector('button[name="checkout"]');

      /* Safety net for a form detached before the browser navigates, which
         cancels the submission outright. Re-attach the SAME form and submit it
         again so everything it carried goes with it -- a cart note, cart
         attributes, a discount field. A bare GET /checkout would silently drop
         all of that, which is why it is only the last resort here.
         form.submit() does not include submit buttons, so the field Shopify
         routes on is added explicitly; it also bypasses submit handlers, so
         this cannot re-enter. Only a checkout submit arms it -- never the
         discount form, never an add form. */
      var isCheckout = !!(e.submitter ? e.submitter.name === 'checkout' : btn);
      if (isCheckout) {
        window.setTimeout(function () {
          if (!checkingOut || navigating || form.isConnected) return;
          try {
            if (!form.querySelector('input[name="checkout"]')) {
              var h = document.createElement('input');
              h.type = 'hidden'; h.name = 'checkout'; h.value = '';
              form.appendChild(h);
            }
            form.hidden = true;
            document.body.appendChild(form);
            form.submit();
          } catch (err) {
            window.location.assign('/checkout');
          }
        }, 400);
      }

      window.setTimeout(function () {
        if (!checkingOut) return;          /* navigated, or already released */
        checkingOut = false;
        if (btn) btn.removeAttribute('aria-busy');
        render();                          /* put the drawer back in a usable state */
        refresh();                         /* and apply any theme redraw we dropped */
      }, 10000);
    }, true);

    /* A real navigation has started: the safety net must not fire behind it. */
    window.addEventListener('pagehide', function () { navigating = true; });
    /* Back button / bfcache returns the shopper to a live page. */
    window.addEventListener('pageshow', function () { checkingOut = false; navigating = false; });

    installReplaceGuards();
  }

  function boot() {
    installReplaceGuards();
    render();
    watch();
    trackOpen();
    guardCheckout();
    ['cart:change', 'cart:refresh', 'variant:add'].forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(render, 250); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
